module.exports = __webpack_public_path__ + "img/happy-message.8ebf0c89.svg";